import { useTranslation } from 'react-i18next';
import {
  Box,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { pathDistanceMeters, formatDistance } from './roadsImporter.helpers';
import { type PendingRoute } from './roadsImporter.constants';

interface PendingRoutesPopoverProps {
  anchorEl: HTMLElement | null;
  pendingRoutes: PendingRoute[];
  onClose: () => void;
  onRemove: (index: number) => void;
}

export function PendingRoutesPopover({
  anchorEl,
  pendingRoutes,
  onClose,
  onRemove,
}: PendingRoutesPopoverProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Menu open={anchorEl !== null} anchorEl={anchorEl} onClose={onClose}>
      <Box sx={{ px: 2, py: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {t('roads_importer_pending_list_title')}
        </Typography>
      </Box>
      {pendingRoutes.map((road, idx) => (
        <MenuItem
          key={road.key}
          disableRipple
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            cursor: 'default',
            '&:hover': { bgcolor: 'transparent' },
          }}
        >
          <ListItemText
            primary={`${road.fromLocationName} → ${road.toLocationName}`}
            secondary={`${formatDistance(pathDistanceMeters(road.path))} · ${
              road.minutes
            } ${t('roads_importer_minutes_suffix')}`}
          />
          <IconButton
            size="small"
            aria-label={t('roads_importer_remove_pending')}
            onClick={() => {
              onRemove(idx);
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </MenuItem>
      ))}
    </Menu>
  );
}
